import t from "./isFunction.js";
import i from "./isLength.js";
function e(r) {
  return r != null && i(r.length) && !t(r);
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isArrayLike.js
// module id = 212
// module chunks = 67